var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IC"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 160610",
    d: "M0 12.4277C0 8.00946 3.58172 4.42773 8 4.42773H18.8657C23.2839 4.42773 26.8657 8.00946 26.8657 12.4277V22.9992C26.8657 27.4174 23.284 30.9992 18.8657 30.9992H8C3.58173 30.9992 0 27.4174 0 22.9992V12.4277Z",
    fill: "#053CC8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 160611",
    d: "M16.5703 6.64286C16.5703 2.97411 19.5444 0 23.2132 0H23.3603C27.029 0 30.0031 2.97411 30.0031 6.64286C30.0031 10.3116 27.029 13.2857 23.3603 13.2857H23.2132C19.5444 13.2857 16.5703 10.3116 16.5703 6.64286Z",
    fill: "#FDB62F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc);
export default __webpack_public_path__ + "static/media/IC.0d48ac2f47b98e6b849bd2c99dcfb7b7.svg";
export { ForwardRef as ReactComponent };